<script>

export default {
  props: {
    topbarControls: {
      type: Object,
      required: true
    },
  },
  methods: {
    deleteSelectedItem() {
      this.topbarControls.onDelFn();
    },
  }
};
</script>
<template>
  <div class="d-flex align-items-center justify-content-between pl-3 border-right-dark">
    <span class="font-weight-medium mb-0">Delete: </span>
    <img class="align-self-center ml-2 cursor-pointer" @click="deleteSelectedItem"
    src="@/assets/images/delbtn.svg" alt="">
  </div>
</template>